import { render, staticRenderFns } from "./StockClosingList.vue?vue&type=template&id=3108bd19&"
import script from "./StockClosingList.vue?vue&type=script&lang=js&"
export * from "./StockClosingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports